import { useSelector } from 'react-redux';
import { VideoCtvRedux } from '../store-types';

export const useScoring = () => {
  const scoringData = useSelector((state: VideoCtvRedux) => state.scoring.data);
  const scoringError = useSelector((state: VideoCtvRedux) => state.scoring.error);
  const games = scoringData?.games;
  return [games, scoringError] as const;
};
